/* eslint-disable import/no-default-export */
import component from './ShippingRequestModal/RequestShippingQuoteModal';
import query from './queries/ShippingRequestModal';
import reducers from './reducers';
import { steps } from './constants';

export default component;

export { reducers, query, steps };
